import { render, staticRenderFns } from "./ListItemPlace.vue?vue&type=template&id=391da1b9&"
import script from "./ListItemPlace.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemPlace.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391da1b9')) {
      api.createRecord('391da1b9', component.options)
    } else {
      api.reload('391da1b9', component.options)
    }
    module.hot.accept("./ListItemPlace.vue?vue&type=template&id=391da1b9&", function () {
      api.rerender('391da1b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemPlace/ListItemPlace.vue"
export default component.exports